<template>
  <div>
    <index-navbar />

    <section class="relative block bg-bgbb-y mobile:pb-32">
      <div class="pt-12 custom-shape-divider-top-1623848228">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>

      <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
        <div class="flex flex-wrap text-center justify-center">
          <div class="w-full lg:w-6/12 px-4 md:pt-16 mobile:pt-40">
            <h2 class="text-3xl text-bgbb-dark">
              KEY FEATURES <br />
              that make the BGBB project unique
            </h2>
          </div>
        </div>

        <!-- ROW III -->

        <div class="flex flex-wrap mt-24 justify-center">
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-heart text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              Reviving Unfairly Defaulted Bonds
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              BGBB has carefully collected a unique set of unclaimed GOLD-BACKED
              Government Bonds and revives them with the power of a unique DeFi
              protocol. So, while earning exponential rewards with BGBB, you
              also support a more significant cause.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-users text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              Earn just by referring people to BGBB
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              Earn BGBB tokens when referring people to BGBB.io. A referred
              stake generates 10% extra shares for the staker, beyond what it
              would have if not referred. Anyone can obtain a referral link to
              earn various referral BGBB bonuses.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-piggy-bank text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              Up to X50 Special Investment Options
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              Get hold of juicy pre-market allocations that have the potential
              to go up in value by a factor of X50 or more. The BGBB protocol
              will distribute 100% of the generated sum proportionally,
              according to users' investments.
            </p>
          </div>
        </div>

        <!-- ROW III END -->

        <!-- ROW IV -->

        <!-- ROW III -->

        <div class="flex flex-wrap mt-24 justify-center">
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-people-carry text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              Open NFT Marketplace [Q4 2021]
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              An open NFT Marketplace will be created to encourage the free and
              open trade of NFTs of unfairly defaulted bonds. People will be
              able to mint their bonds as an NFT and then put them for sale or
              auction.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-credit-card text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              On-ramp exchange [Q4 2021]
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              <br />
              Easily exchange fiat money for BGBB or any other cryptocurrency
              via credit/debit card or a bank transfer.
            </p>
          </div>
          <div class="w-full lg:w-4/12 px-4 text-center">
            <div
              class="text-white p-3 w-12 h-12 inline-flex items-center justify-center"
            >
              <i class="fas fa-dice text-5xl"></i>
            </div>
            <h5 class="text-2xl mt-5 text-bgbb-dark">
              Decentralized Lottery [Q4 2021]
            </h5>
            <p class="mt-2 mb-4 text-bgbb-dark">
              Global, decentralized, transparent, and hyper-connected Lottery.
              No scams or faulty operators. Blockchain technology and smart
              contracts ensure unparalleled transparency to win the trust of
              users.
            </p>
          </div>
        </div>
      </div>

      <div class="custom-shape-divider-bottom-1623848778">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
          ></path>
        </svg>
      </div>
    </section>

    <section class="py-1 bg-dark-bgbbnav overflow-hidden">
      <div class="container mx-auto pb-16">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <!-- <div 
              class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-bgbb-y"
            >
              <i class="fas fa-percent text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 leading-normal text-white">
              Stake & Promote BGBB - Earn More. <br />
              BGBB rewards stakers & promoters,
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              NOT miners. BGBB is essentially an ADA Bond, which uses the Time
              Value of Money principle to lock up ADA at a given price per BGBB.
              Similar to how Bitcoin rewards miners every 10 minutes, BGBB
              rewards stakers every day. A steady rate of 4% annual inflation is
              used to create the interest pool. Stakers can increase their share
              by staking longer.
              <br />In addition, The BGBB contract has a direct, one-level
              referral system that rewards both the referrer and referee with up
              to 10% on top when a user reserves BGBB tokens. This referral
              system is an incentive to popularise the platform, as well as help
              increase the amount of ADA sent in. In turn, this will allow
              funding a larger and more robust initial liquidity pool on Sundaeswap.
            </p>

            <router-link
              class="github-star mt-4 inline-block text-white font-semibold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-bgbb-y uppercase text-sm shadow"
              to="#"
            >
              <i class="fas fa-coins"></i> BGBB Staking
            </router-link>
            <router-link
              class="github-star mt-4 inline-block font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white uppercase text-sm shadow"
              to="#"
            >
              Buy BGBB <i class="fas fa-long-arrow-alt-right"></i>
            </router-link>

            <br />

            <br />

            <a href="#rewards" target="_self" class="text-white">
              More About Rewards <i class="fas fa-level-down-alt"></i>
            </a>
          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto relative mt-max">
            <i
              class="fa fa-percent text-bgbb-y text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- EARN EXPODENTION  -->

    <section class="py-10 bg-bgbb-y overflow-hidden">
      <div id="rewards" class="container mx-auto pb-32">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <!-- <div 
              class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-bgbb-y"
            >
              <i class="fas fa-percent text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 leading-normal text-white">
              Make exponential rewards <br />
              even during bear markets
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              The pure design and fair distribution of BGBB create the potential
              for exponential gains over extended stakes, long after other
              cryptos would have failed. Since a pool of ADA backs BGBB, BGBB
              investors experience the safety of the #3 market cap crypto while
              also having the potentially explosive growth of a new project.
              <br />
              Of course, both markets can also go down in value, but that's
              where staking comes in. Staking is the best way to earn,
              especially in a bear market, since investors earn more BGBB tokens
              for the duration. Once the market recovers, investors realize a
              profit from the interest they earned during the downtrend.
            </p>
          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-48 relative">
            <i
              class="fa fa-sort-numeric-up-alt text-white text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- Governance -->

    <section class="py-10 bg-dark-bgbbnav overflow-hidden">
      <div id="governance" class="container mx-auto pb-32">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <!-- <div 
              class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-bgbb-y"
            >
              <i class="fas fa-percent text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 leading-normal text-white">
              Governance: holders are in charge of the future of the BGBB smart
              contract and dApp
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              The BGBB dApp will enable BGBB token-holders to propose, vote, and
              implement changes. Proposals can include adjusting the taxes rate
              model, switching to a different chain, investment plans, lottery,
              staking duration, or whatever is found necessary.
              <br />
              Token-holders can either vote on each proposal or delegate their
              votes to a third party. BGBB Governance puts you in charge of the
              future of the BGBB token and dApp.
            </p>
          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-48 relative">
            <i
              class="fa fa-university text-bgbb-y text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- Governance end -->

    <!-- NFT MINTING -->

    <section class="py-10 bg-bgbb-y overflow-hidden">
      <div id="nftminting" class="container mx-auto pb-64">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <!-- <div 
              class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-bgbb-y"
            >
              <i class="fas fa-percent text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 leading-normal text-white">
              Open NFT Marketplace everyone can use
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              An open NFT Marketplace will be created to encourage the free and
              open trade of NFTs of unfairly defaulted bonds. People will be
              free to mint their unfairly defaulted bond as an NFT and then put
              it for sale or auction. That way, the BGBB NFT Marketplace will
              develop as a fair and open assessment platform for unfairly
              defaulted bonds.
              <br />
              (on mainnet by Q4 2021)
            </p>

              <router-link
              class="mt-4 inline-block text-white font-semibold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-bgbb-1 text-sm shadow"
              to="/NFT-marketplace"
            >
              <i class="fas fa-shapes"></i> Visit NFT Marketplace
            </router-link>
            <router-link
              class="mt-4 inline-block font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white text-sm shadow"
              to="/mint-nft"
            >
              Mint Your NFT <i class="fas fa-long-arrow-alt-right"></i>
            </router-link>



          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-48 relative">
            <i
              class="fa fa-people-carry text-white text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- NFT MINGINT END -->

    <section class="mt-0 md:mt-1 pb-1 relative bg-dark-bgbbnav">
      <div class="container mx-auto px-4 pb-32 pt-12">
        <div class="items-center flex flex-wrap">
          <div class="w-full md:w-6/12 ml-auto md:px-4 mobile:px-2">
            <div class="md:pr-12">
              <h3 class="text-3xl text-white">
                Mission: Reviving Unfairly Defaulted Government Bonds & Giving
                Back to their owners
              </h3>
              <p class="mt-4 text-lg leading-relaxed text-white text-justify">
                In parts of Europe, hundreds of GOLD BACKED Government Bonds
                were unfairly declared worthless and defaulted due to various
                political reasons. This left generations deprived of their
                lawful right to cash out on their and their ancestors'
                investments. BGBB gives new life to these beautiful historical
                papers, turns them into NFTs, and puts them into its own DeFi
                smart protocol. All this is wrapped in a robust yield-generating
                DeFi protocol, which will allow all participants to profit.
                <br />
                So, while earning exponential rewards with BGBB, you also
                support a more significant cause.
              </p>
              <ul class="list-none mt-6">
                <li class="py-2">
                  <div class="flex items-center">
                    <div>
                      <span
                        class="text-xs inline-block py-1 px-2 uppercase rounded-full text-gray-600 bg-gray-100 mr-3"
                      >
                        <i class="fas fa-fingerprint"></i>
                      </span>
                    </div>
                    <div>
                      <h4 class="text-white">
                        Carefully Selected Collection of Unique Gold-Backed
                        Unclaimed Government Bonds from the early 20th Century
                      </h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="flex items-center">
                    <div>
                      <span
                        class="text-xs inline-block py-1 px-2 uppercase rounded-full text-gray-600 bg-gray-100 mr-3"
                      >
                        <i class="fab fa-html5"></i>
                      </span>
                    </div>
                    <div>
                      <h4 class="text-white">
                        Chose the bond you want from the collection and have it
                        shipped anywhere in the world receive it (framed as in
                        picture)
                      </h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="flex items-center">
                    <div>
                      <span
                        class="text-xs inline-block py-1 px-2 uppercase rounded-full text-gray-600 bg-gray-100 mr-3"
                      >
                        <i class="far fa-paper-plane"></i>
                      </span>
                    </div>
                    <div>
                      <h4 class="text-white">
                        NFT of the chosen bond will be minted and sent to your
                        wallet.
                      </h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <br /><br />
            <a
              href="/BGBB-NFT-marketplace"
              class="shadow-xl github-star ml-1 font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white uppercase text-sm"
              target="_self"
            >
              About the bonds
            </a>
          </div>

          <div class="w-full md:w-6/12 mr-auto px-4 pt-24 md:pt-0 z-2">
            <img
              alt="..."
              class="max-w-full rounded-lg shadow-xl z-2"
              style="
                transform: scale() perspective(1040px) rotateY(-11deg)
                  rotateX(2deg) rotate(2deg);
              "
              :src="documentation"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- SPECIAL INVESTMENT -->

    <section class="py-10 bg-bgbb-y overflow-hidden">
      <div class="container mx-auto pb-64">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <!-- <div 
              class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-bgbb-y"
            >
              <i class="fas fa-percent text-xl"></i>
            </div> -->
            <h3 class="text-3xl mb-2 leading-normal text-white">
              Special Investment Plans
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              Users can choose to deposit a sum to a public address, which will
              invest 100% of the funds in pre-market allocations, most of which
              are off-limits for the average investor. All of these pre-market
              allocations have the potential to go up in value by a factor of
              x50 or more. BGBB will distribute 100% of all profits
              proportionally to each user, according to their initial
              investment.
            </p>
          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-48 relative">
            <i
              class="fa fa-piggy-bank text-white text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- SPECIAL INVESTMENT END -->

    <!-- TEAM FOR THE CAUSE -->

    <section class="py-10 bg-dark-bgbbnav overflow-hidden">
      <div id="governance" class="container mx-auto pb-32">
        <div class="flex flex-wrap justify-center">
          <div class="w-full md:w-6/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
            <h3 class="text-3xl mb-2 leading-normal text-white">
              0% Team Allocation. All in for the cause!
            </h3>
            <p
              class="text-lg font-light leading-relaxed mt-4 mb-4 text-white text-justify"
            >
              BGBB works to give back to the generations deprived of their
              lawful right to cash out on their investments because of different
              political reasons in history.
              <br />
              Before deploying the BGBB contract, the BGBB team will determine
              its total expenses for developing and launching BGBB (wages paid
              to developers, marketing spends, audit costs.) plus the amount to
              be paid to the bondholders. The team working on the project will
              receive no token allocations or claim any profit whatsoever.
            </p>

            <br />

            <a
              href="https://github.com/BGBB-token/papers/raw/main/White_Paper_V2.0.pdf"
              class="shadow-xl github-star ml-1 font-semibold text-dark px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-white  text-sm"
              target="_self"
            >
              <i class="fas fa-book"></i> White Paper
            </a>
            <a
              href="https://github.com/BGBB-token/papers/raw/main/Technical_Paper_V2.0.pdf"
              class="shadow-xl github-star ml-1 font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-dark-bgbb100 text-sm"
              target="_self"
            >
             Technical Paper  <i class="fas fa-long-arrow-alt-right"></i>
            </a>
          </div>

          <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-48 relative">
            <i
              class="fa fa-heart text-bgbb-y text-25 absolute -top-20-px -right-20 left-auto"
            ></i>
          </div>
        </div>
      </div>
    </section>

    <!-- TEAM FOR THE CAUSE END -->

    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";

import FooterComponent from "@/components/Footers/Footer.vue";

import documentation from "@/assets/img/documentation.png";
import NFT1_img from "@/assets/img/Government_Bond_282781.jpg";
import NFT2_img from "@/assets/img/Government_Bond_057187.png";
import NFT3_img from "@/assets/img/Government_Bond_056737.png";


export default {
  data() {
    return {
      documentation,
      NFT1_img,
      NFT2_img,
      NFT3_img,
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },


};
</script>
